import { categories } from '@/mocks/communityData';
import SectionHeading from './SectionHeading';

const accentIcon: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-900',
};

export default function Categories() {
  return (
    <section id="categories" className="bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="内容分类"
          title="六大主题区，想看哪类的料都有同好"
          desc="把看料心得按兴趣领域划分成六大主题区，进去就能直奔感兴趣的内容，交流更高效。"
          align="center"
        />
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c, i) => {
            const color = accentIcon[[
              'primary',
              'accent',
              'secondary',
              'accent',
              'primary',
              'secondary',
            ][i % 6]];
            return (
              <a
                key={c.name}
                href="#categories"
                onClick={(e) => e.preventDefault()}
                className="group rounded-xl border border-background-200/80 bg-background-100 p-5 transition-colors hover:border-accent-300 hover:bg-background-50 cursor-pointer"
              >
                <div className={`flex h-12 w-12 items-center justify-center rounded-lg ${color}`}>
                  <i className={`${c.icon} text-2xl`}></i>
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
                  <i className="ri-arrow-right-line text-foreground-400 transition-transform group-hover:translate-x-1 group-hover:text-primary-600"></i>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <p className="mt-3 text-xs font-medium text-foreground-400">{c.postCount}</p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}